import { Hooks } from 'service-api'
import { VoucherFilterParams } from 'service-api/src/services'

interface UsePackageCreditsProps {
  locationName: string
  locationUserProfileId: string
  enabled: boolean
}

export const usePackageCredits = ({ locationName, locationUserProfileId, enabled }: UsePackageCreditsProps) => {
  const baseParams = {
    enabled,
    locationUserProfile: locationUserProfileId,
    type: 'OFFER',
    status: 'ACTIVE',
  } as VoucherFilterParams

  const { data: available, isLoading: isLoadingAvailable } = Hooks.useClientCreditVouchers(
    locationName,
    {
      ...baseParams,
      atLeastOneAvailable: true,
      expired: false,
      isUsed: false,
    },
    true
  )

  const { data: redeemed, isLoading: isLoadingRedeemed } = Hooks.useClientCreditVouchers(
    locationName,
    {
      ...baseParams,
      isUsed: true,
    },
    true
  )

  const { data: expired, isLoading: isLoadingExpired } = Hooks.useClientCreditVouchers(
    locationName,
    {
      ...baseParams,
      expired: true,
    },
    true
  )

  return {
    available,
    redeemed,
    expired,
    isLoading: isLoadingAvailable || isLoadingRedeemed || isLoadingExpired,
  }
}
